import { FlowCategoriesT } from 'components/powerFlowShared/helpers/flowVariableHelpers';

import { FlowVariable } from '../variableSelector';

export function formatVariablesForTextInput(
  variables: FlowCategoriesT,
): FlowVariable[] {
  return variables
    .flatMap(({ items }) => items)
    .filter(({ name }) => !!name)
    .map(({ content, name }) => ({
      key: name,
      label: content,
      searchableName: content,
    }));
}
